import ApiClient from './ApiClient';

class CommitteeClient {
  constructor(authToken) {
    this.apiClient = new ApiClient();
    this.gatewayUri = 'api/v1';
    this.latestVersion = 'v1';
    this.baseUri = process.env.VUE_APP_HACKATHON_SERVICE_URI;
    this.headers = {
      Authorization: `Bearer ${authToken}`,
    };
    this.params = {};
  }

  getCommitteeMembers() {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/committee`, {}, this.headers)
      .then((response) => response.data);
  }

  addMember(email) {
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/committee/${email}`, {}, this.headers)
      .then((response) => response.data);
  }

  removeMember(email) {
    return this.apiClient.delete(`${this.baseUri}${this.gatewayUri}/committee/${email}`, {}, this.headers)
      .then((response) => response.data);
  }
}
export default CommitteeClient;
